import {
  TreeComponent,
  TreeModule,
  TreeNode,
} from '@ali-hm/angular-tree-component';
import { Component, input, output, signal, ViewChild } from '@angular/core';
import { ItemComponent } from '../item/item.component';
@Component({
  standalone: true,
  selector: 'app-tree-root',
  imports: [ItemComponent, TreeModule],
  templateUrl: './tree-root.component.html',
  styleUrl: './tree-root.component.scss',
})
export class TreeRootComponent {
  @ViewChild(TreeComponent) treeRoot: TreeComponent;

  readonly onMovedNode = output();
  readonly nodes = input.required<Array<TreeNode>>();

  expandedItems = signal([]);
  options = input.required({});

  moveNode($event) {
    this.onMovedNode.emit($event);
  }

  updateModel() {
    if (this.treeRoot) {
      this.treeRoot.treeModel.update();
    }
  }

  blurFocusedNodes(): void {
    const focusedNode = this.treeRoot.treeModel.getFocusedNode();
    if (focusedNode) {
      if (focusedNode.isActive) {
        focusedNode.toggleActivated();
      }
      focusedNode.blur();
    }
  }

  private getTreeNodeById(id: string) {
    return this.treeRoot.treeModel.getNodeById(id);
  }

  expandById(id: string) {
    const node = this.getTreeNodeById(id);
    if (node) {
      node.expand();
    }
  }

  expandItemDetails(data: {
    itemId: string;
    isExpanded: boolean;
    isHistoryExpanded: boolean;
  }) {
    this.expandedItems.update((state) => {
      // Check if the item already exists in the state
      const item = state.find((item) => item.itemId === data.itemId);
      if (item) {
        item.isExpanded = data.isExpanded;
        item.isHistoryExpanded = data.isHistoryExpanded;
        return [...state];
      } else {
        // If the item does not exist, add it to the state
        return [...state, data];
      }
    });
  }

  collapseExpandedItem(node: TreeNode) {
    return this.expandedItems().some((element) => {
      return node.data.id === element.itemId && element.isExpanded;
    });
  }

  collapseExpandedItemHistory(node: TreeNode) {
    return this.expandedItems().some((element) => {
      return node.data.id === element.itemId && element.isHistoryExpanded;
    });
  }
}
